import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPrescriptionBottleMedical = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 14H14M12 12V16M7 8H17V16.8C17 17.9201 17 18.4802 16.782 18.908C16.5903 19.2843 16.2843 19.5903 15.908 19.782C15.4802 20 14.9201 20 13.8 20H10.2C9.07989 20 8.51984 20 8.09202 19.782C7.71569 19.5903 7.40973 19.2843 7.21799 18.908C7 18.4802 7 17.9201 7 16.8V8ZM6 4H18V8H6V4Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPrescriptionBottleMedical;
